namespace Areas.Analysis.ProjectsGantt {
    "use strict";

    export function goToProject(e: any) {
        const grid = $("#ProjectsGanttAnalysisGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Account/Profile/View/" + id;
            window.open(linkInfo);
        }
    }


}